var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconParkSolidCheckOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3556_58138",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 11C6.65673 11.0008 7.30715 10.8719 7.91388 10.6205C8.52062 10.3692 9.07171 10.0005 9.5355 9.5355C10.0005 9.07171 10.3692 8.52062 10.6205 7.91388C10.8719 7.30715 11.0008 6.65673 11 6C11.0008 5.34328 10.8719 4.69286 10.6205 4.08613C10.3692 3.47939 10.0005 2.9283 9.5355 2.4645C9.07171 1.99954 8.52062 1.63081 7.91388 1.37948C7.30715 1.12816 6.65673 0.999194 6 1C5.34328 0.999194 4.69286 1.12816 4.08613 1.37948C3.47939 1.63081 2.9283 1.99954 2.4645 2.4645C1.99954 2.9283 1.63081 3.47939 1.37948 4.08613C1.12816 4.69286 0.999194 5.34328 1 6C0.999194 6.65673 1.12816 7.30715 1.37948 7.91388C1.63081 8.52062 1.99954 9.07171 2.4645 9.5355C2.9283 10.0005 3.47939 10.3692 4.08613 10.6205C4.69286 10.8719 5.34328 11.0008 6 11Z",
    fill: "white",
    stroke: "white",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6L5.5 7.5L8.5 4.5",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3556_58138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H12V12H0V0Z",
    fill: "#333333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconParkSolidCheckOne);
export default __webpack_public_path__ + "static/media/icon-park-solid_check-one.dc457974720365c129d34a9242bfd7d1.svg";
export { ForwardRef as ReactComponent };